import "normalize.css";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import App from "@Components/App";
import SmartAppBanner from "@Components/atoms/SmartAppBanner";
import BannerKountries from "@Components/molecules/BannerKountries";
import NotificationsArea from "@Components/molecules/cart/NotificationsArea";
import NotificationsProvider from "@Components/NotificationsStateProvider";
import Drafts from "@Components/organisms/Drafts";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";
import WithLocale from "@Components/WithLocale";
import { extractQueryParams } from "@Lib/router/utils";
import { BugsnagErrorBoundary } from "./bugsnag";
import "./index.scss";

const history = createBrowserHistory();

const rootElement = document.getElementById("root");

if (rootElement) {
  ReactDOM.render(
    BugsnagErrorBoundary ? (
      <BugsnagErrorBoundary>
        <App />
      </BugsnagErrorBoundary>
    ) : (
      <App />
    ),
    rootElement
  );
}

const isCheerzApp: () => boolean = () => {
  const cheerzAppValue: string = extractQueryParams(window.location.search)["cheerz-app"];
  return cheerzAppValue !== undefined && cheerzAppValue === "true";
};

const bannerKountriesElement = document.getElementById("BannerKountriesComponent");

if (bannerKountriesElement) {
  ReactDOM.render(<BannerKountries />, bannerKountriesElement);
}

const headerElement = document.getElementById("HeaderComponent");

if (headerElement && !isCheerzApp()) {
  ReactDOM.render(
    <WithLocale history={history}>
      <NotificationsProvider>
        <Header />
        <div className="Header-notifications">
          <NotificationsArea />
        </div>
      </NotificationsProvider>
    </WithLocale>,
    headerElement
  );
}

const smartAppBannerElement = document.getElementById("SmartAppBannerComponent");

if (smartAppBannerElement) {
  ReactDOM.render(<SmartAppBanner />, smartAppBannerElement);
}

const draftsElement = document.getElementById("DraftsComponent");

if (draftsElement) {
  ReactDOM.render(<Drafts />, draftsElement);
}

const footerElement = document.getElementById("FooterComponent");

if (footerElement) {
  ReactDOM.render(
    <WithLocale history={history}>
      <Footer />
    </WithLocale>,
    footerElement
  );
}
